import { RedoModalHostElement } from "../modal-host-element";

export class RedoDeliveryEstimateContainerElement extends RedoModalHostElement {
  constructor() {
    super("redo-delivery-estimate-modal-root");
  }

  static readonly TAG = "redo-delivery-estimate-container-element";
}
